  // CyberSecurity Skills ID list
  export const csSkillsSet = [1, 3, 4, 5, 8, 11, 12, 13, 14, 15, 16, 20, 24, 29, 30];

  // Other IT Skills ID list
  export const itSkillsSet = [6, 7, 10, 17, 18, 25, 27];

  // SOFT Skills ID list
  export const softSkillsSet = [2, 9, 19, 21, 22, 23, 26, 28, 31];


  export const importJsonFile = (event, importData) => {
    const file = event.target.files[0];
    if (event.target.files.length && file.type.match('application/json')) {
      const reader = new FileReader();
      reader.onload = function () {
        importData(reader.result);
      };
      reader.readAsText(file);
    }
  };